import { Controller } from "@hotwired/stimulus"

// Keeps the address bar in sync when a conversation thread is opened, so a refresh reopens the
// same thread. The row's Turbo-Frame link still loads the thread into the "conversation" frame;
// this only records ?open=<id> on the current list URL. replaceState (not pushState) avoids
// history spam on repeated opens and never fights Turbo's own popstate handling — Back returns
// to the list the thread was opened from.
export default class extends Controller {
  open(event) {
    const id = event.params.id
    if (!id) return

    this.syncListSelection(id, event.currentTarget)

    const url = new URL(window.location)
    url.searchParams.set("open", id)
    history.replaceState(history.state, "", url)
  }

  // active-link is scoped to the list, so a thread opened from anywhere else — the info rail's
  // "From this sender" links — would leave the list lighting the row it was opened FROM. This
  // controller sits on the shell, above both panes, and already owns which thread is open; the
  // highlighted row is the same fact.
  //
  // A no-op when that thread is not in the list being viewed (another scope, filter or search),
  // which is the honest answer: nothing there is the open thread, so nothing is lit. Idempotent
  // for a list row, which fires active-link#select alongside this and lands on the same element.
  //
  // Notifications can list the same thread twice (two events on one conversation), so the
  // clicked row is preferred over "the first row for this conversation".
  syncListSelection(id, clicked) {
    this.element.querySelectorAll(".conversation-row__link[aria-current], .notification-row__link[aria-current]")
      .forEach((link) => link.removeAttribute("aria-current"))

    if (clicked?.classList.contains("notification-row__link")) {
      clicked.setAttribute("aria-current", "true")
      return
    }

    this.element.querySelector(`#conversation_${id} .conversation-row__link`)
      ?.setAttribute("aria-current", "true")
  }
}
